module.exports = __webpack_public_path__ + "img/es-mb-s5.e720a9d0.png";